import styled from 'styled-components';
import { COLORS } from '@app/constants/STYLES';

export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  margin-right: 210px;
  width: 300px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  z-index: 999 !important;
  padding: 0 !important;
`;

export const HeaderButtonSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  width: 36px;
  height: 36px;
  align-self: center;
  margin: 0 4px;

  color: ${(props) => props.theme.COLORS.textw};

  &:hover ${DropdownContent} {
    display: block;
  }
`;
export const HeaderProfieSection = styled.div`
  background-color: ${({ theme }) => theme.COLORS.DropdownBg};
  font-family: 'Pretendard', sans-serif;
  border-radius: 10px;
  overflow: hidden;
`;
export const HeaderProfieUid = styled.div`
  margin-left: 4px;
  padding-block: 10px;
  text-align: start;
`;
export const HeaderButtonText = styled.div`
  margin-left: 1rem;
  padding-right: 0.3rem;
  font-size: 13px;

  &:hover {
    color: ${COLORS.white};
  }
`;
export const AuthHeaderMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 900px) {
    display: none;
  }
`;
